export default "__VITE_ASSET__e90e2415__"